/* src/app/core/layout/navbar/navbar.component.scss */
:root {
  --cf-brand: #e3fd64;
  --cf-brand-dark: #4d7a00;
  --cf-brand-light: #f9ffe0;
  --cf-chrome: #1d2530;
  --cf-bg: #f4f6f8;
  --cf-surface: #ffffff;
  --cf-surface-hover: #f9fafc;
  --cf-text: #1a1d23;
  --cf-text-muted: #6b7280;
  --cf-text-on-dark: rgba(255, 255, 255, 0.87);
  --cf-border: #e5e7eb;
  --cf-border-strong: #d1d5db;
  --cf-radius: 8px;
  --cf-radius-sm: 4px;
  --cf-radius-lg: 12px;
  --cf-shadow-sm: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.06);
  --cf-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.07), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --cf-success: #16a34a;
  --cf-warning: #d97706;
  --cf-error: #dc2626;
}
.navbar {
  width: 100%;
  overflow: auto;
}
.navbar-icon {
  color: #1a1d23 !important;
  margin-bottom: 1px;
}
.navbar-icon:hover,
.navbar-icon:active,
.navbar-icon-Active {
  color: #e3fd64 !important;
  border-bottom: solid 2px #e3fd64 !important;
  border-radius: 0%;
  margin-bottom: 0px;
}
.logo-web {
  width: 350px;
}
.hello-user-navbar {
  width: max-content;
  font-size: 20px;
  font-weight: 500;
  font-family: "Inter Tight", sans-serif;
}
.nav-link {
  display: inline;
  padding: 0;
  font-size: 18px;
}
.navbarOption {
  padding-bottom: 12px;
  text-decoration: none;
  font-size: 18px;
  text-align: center;
  color: #6b7280;
}
@media (min-width: 768px) {
  .navbar-toggleable-sm .navbar-collapse {
    justify-content: space-between;
  }
  .navbar-toggleable-sm .nav-var-top-top-end-custom {
    justify-content: end;
  }
}
.navbarOption:active a,
.navbarOption:hover a,
.navbarOption.active a {
  color: #e3fd64 !important;
  border-bottom: solid 2px #e3fd64 !important;
  border-radius: 0%;
  padding-bottom: 5px !important;
}
@media screen and (max-width: 500px) {
  .navbarOption {
    float: none;
    display: block;
    width: 100%;
    text-align: left;
  }
}
mat-toolbar {
  border-radius: 3px;
}
.notification {
  top: 0px;
}
.notification .badge {
  position: absolute;
  top: -15%;
  right: -15%;
  padding: 15% 20%;
  border-radius: 25%;
  background: red;
  color: white;
}
.vertical-align-middle {
  vertical-align: -24%;
}
@media (max-width: 1199.98px) {
  .hello-user-navbar {
    font-size: 16px;
  }
  .logo-web {
    width: 300px;
  }
}
@media (max-width: 959px) {
  mat-toolbar {
    border-radius: 0px;
  }
}
@media (max-width: 400px) {
  mat-toolbar * {
    display: block;
  }
  .navbar {
    height: min-content;
  }
}
@media (max-width: 991px) {
  .logo-web {
    width: 350px;
  }
}
@media (max-width: 769px) {
  .hello-user-navbar {
    font-size: 16px;
  }
  .logo-web {
    width: 215px;
  }
}
@media (max-width: 768px) {
  .logo-web {
    width: 285px;
  }
}
@media (max-width: 575.98px) {
  .logo-web {
    width: 100%;
  }
  .hello-user-navbar {
    text-align: center;
  }
}
/*# sourceMappingURL=navbar.component.css.map */
